import React from "react";
import { Link } from "react-router-dom";
import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Projects", href: "/portfolio" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <footer className="relative bg-gradient-to-b from-gray-900 via-gray-950 to-black text-gray-300 overflow-hidden">
      {/* Top Glow Line */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-blue-600 via-purple-500 to-indigo-600" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-extrabold bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-500 bg-clip-text text-transparent mb-4">
              Shihab Uddin
            </h3>
            <p className="text-gray-400 leading-relaxed text-sm">
              Full-stack developer crafting premium digital experiences with
              modern, elegant, and functional design.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative inline-block">
              Quick Links
              <span className="absolute -bottom-1 left-0 w-12 h-[2px] bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></span>
            </h4>
            <div className="space-y-2">
              {links.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-300"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative inline-block">
              Connect
              <span className="absolute -bottom-1 left-0 w-12 h-[2px] bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></span>
            </h4>
            <div className="flex space-x-4">
              {[
                {
                  href: "https://github.com/infoshihab",
                  icon: <FiGithub size={22} />,
                },
                {
                  href: "https://www.linkedin.com/in/shihabuddiin/",
                  icon: <FiLinkedin size={22} />,
                },
                {
                  href: "mailto:infoshihab00000@gmail.com",
                  icon: <FiMail size={22} />,
                },
              ].map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 rounded-xl bg-gray-800/50 backdrop-blur-lg text-gray-300 border border-gray-700 hover:border-blue-500 hover:text-white hover:shadow-[0_0_15px_rgba(59,130,246,0.6)] transition-all duration-300"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="border-t border-gray-800 mt-12 pt-6 text-center text-sm text-gray-500">
          <p>© {currentYear} Shihab Uddin. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
